export default "__VITE_ASSET__LC$lVRNw__"